import { useQuery } from '@tanstack/react-query';
import { api, type Me } from '../lib/api.js';

/**
 * Current-user hook. Fetches /api/v1/me on first call and caches.
 *
 * Used everywhere — nav rendering, RBAC checks, RTL toggle defaults.
 * On 401 the api interceptor redirects to /login.
 */
export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const { data } = await api.get<Me>('/api/v1/me');
      return data;
    },
    retry: false,
    staleTime: 60_000,
  });
}

export function useHasPermission(
  module: 'cleanops' | 'pantry' | 'platform' | 'agent' | 'shared',
  perm: 'view' | 'create' | 'edit' | 'delete' | 'approve' | 'admin',
) {
  const { data: me } = useMe();
  if (!me) return false;
  return (me.permissions[module] ?? []).includes(perm);
}
